'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: {
        network: Object
    },
    data: function data() {
        return {
            new_nick: '',
            error_message: '',
            self_user_settings_open: false
        };
    },
    computed: {
        modeString: function modeString() {
            var str = '';
            this.network.ircClient.user.modes.forEach(function (mode) {
                str += mode;
            });

            if (str) {
                str = '+' + str;
            }

            return str;
        },
        netUser: function netUser() {
            return this.network.ircClient.user;
        },

        awayStatus: {
            get: function get() {
                return this.network.currentUser().away;
            },
            set: function set(val) {
                this.network.ircClient.raw('AWAY', val ? 'Currently away' : '');
            }
        }
    },
    created: function created() {
        var _this = this;

        this.listen(this.network.ircClient, 'nick in use', function (event) {
            _this.error_message = TextFormatting.t('error_nick_in_use', { nick: event.nick });
        });
    },

    methods: {
        openSelfActions: function openSelfActions() {
            this.self_user_settings_open = true;
        },
        closeSelfUser: function closeSelfUser() {
            this.$emit('close');
        },
        onNewNickSubmit: function onNewNickSubmit(newVal) {
            this.new_nick = newVal;
            this.changeNick();
        },
        changeNick: function changeNick() {
            var nick = this.new_nick.trim();
            if (nick.length === 0) {
                this.error_message = TextFormatting.t('error_empty_nick');
                return;
            }
            if (nick.match(/(^[0-9])|(\s)/)) {
                this.error_message = TextFormatting.t('error_no_number');
                return;
            }
            this.error_message = '';
            this.network.ircClient.changeNick(nick);
            this.userNameCancel();
        },
        userNameCancel: function userNameCancel() {
            this.self_user_settings_open = false;
        },
        networkSupportsAway: function networkSupportsAway() {
            return this.network.ircClient.network.cap.isEnabled('away-notify');
        },
        checkUserAway: function checkUserAway() {
            return !!this.network.currentUser().away;
        },
        getUserFromString: function getUserFromString(name) {
            return this.$state.getUser(this.network.id, name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SelfUser"]
window._kiwi_exports.components.SelfUser = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelfUser.vue
// module id = cC0S
// module chunks = 1